import { useMediaQuery, useTheme } from "@mui/material";

const useBreakpoint = () => {

  const theme = useTheme();

  const mq_xs = useMediaQuery(theme.breakpoints.only('xs'));
  const mq_sm = useMediaQuery(theme.breakpoints.only('sm'));
  const mq_md = useMediaQuery(theme.breakpoints.only('md'));
  const mq_lg = useMediaQuery(theme.breakpoints.only('lg'));

  const getBreakPointName = () => {
    if(mq_xs) return 0
    if(mq_sm) return 1
    if(mq_md) return 2
    if(mq_lg) return 3
    return 4
  }

  return { getBreakPointName }
}

export default useBreakpoint 